var _circle, _circle2, _circle3, _path, _circle4, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 95,
    viewBox: "0 0 82 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#F58120"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "url(#paint0_linear)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.6846,
    cy: 32.0919,
    r: 12.7217,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6841 48.2061C21.29 48.2061 8 61.4961 8 77.8901H67.3681C67.3681 61.4961 54.0781 48.2061 37.6841 48.2061Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 76,
    r: 19,
    fill: "#FFB900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.884 79.344C55.804 79.344 56.556 78.98 57.14 78.252L58.34 79.488C57.388 80.56 56.264 81.096 54.968 81.096C53.68 81.096 52.616 80.688 51.776 79.872C50.944 79.056 50.528 78.028 50.528 76.788C50.528 75.54 50.952 74.5 51.8 73.668C52.656 72.836 53.7 72.42 54.932 72.42C56.308 72.42 57.46 72.944 58.388 73.992L57.224 75.312C56.632 74.576 55.896 74.208 55.016 74.208C54.312 74.208 53.708 74.44 53.204 74.904C52.708 75.36 52.46 75.98 52.46 76.764C52.46 77.54 52.696 78.164 53.168 78.636C53.64 79.108 54.212 79.344 54.884 79.344ZM66.1091 72.612V74.28H61.9331V76.008H65.6891V77.604H61.9331V79.344H66.2411V81H60.0611V72.612H66.1091ZM74.4437 76.764C74.4437 76.012 74.2037 75.372 73.7237 74.844C73.2437 74.316 72.6517 74.052 71.9477 74.052C71.2517 74.052 70.6637 74.316 70.1837 74.844C69.7037 75.372 69.4637 76.012 69.4637 76.764C69.4637 77.508 69.7037 78.144 70.1837 78.672C70.6637 79.192 71.2517 79.452 71.9477 79.452C72.6517 79.452 73.2437 79.192 73.7237 78.672C74.2037 78.144 74.4437 77.508 74.4437 76.764ZM75.0797 79.848C74.2317 80.672 73.1877 81.084 71.9477 81.084C70.7077 81.084 69.6637 80.672 68.8157 79.848C67.9677 79.016 67.5437 77.984 67.5437 76.752C67.5437 75.52 67.9677 74.492 68.8157 73.668C69.6637 72.836 70.7077 72.42 71.9477 72.42C73.1877 72.42 74.2317 72.836 75.0797 73.668C75.9277 74.492 76.3517 75.52 76.3517 76.752C76.3517 77.984 75.9277 79.016 75.0797 79.848Z",
    fill: "#1E334E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.00000161558,
    y1: 7.98027,
    x2: 76.2922,
    y2: 8.30956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCeo);
export default __webpack_public_path__ + "static/media/user-ceo.711774cd55f123884f92d4faa61e6d39.svg";
export { ForwardRef as ReactComponent };